export default __webpack_public_path__ + "3166c3d34a0818b0e2ee6d9b15191750.png";